<template>
  <!--  ant-layout-->
  <!--<div class="UseModal"></div>-->
  <div>
    <vxe-modal
      :title="modalTitle"
      v-model="modalVisible"
      :height="modalHeight"
      class="ie-height"
      :className="className"

      :position="position"
      show-footer
      show-zoom
      transfer
      :width="modalWidth"
      @close="handleCancel"
      @zoom="handleZoom"
    >
      <slot></slot>
      <template slot="footer">
        <div
          style="position: absolute;left: 20px;top: 15px;font-weight:550"
          v-if="confirmStatus">
          <span style="color: red">当前状态：{{ statusType }}</span>
        </div>
        <a-button
          style="margin-top:10px"
          v-if="modalShou"
          type="primary"
          @click="handleEvent(item.method)"
          v-for="(item, index) in ModalBtnList"
          :key="index"
          :disabled="spinning || item.disabled"
          v-show="!item.show"
        >
          {{ item.name + (spinning ? "(正在提交...)" : "")}}
        </a-button>
<!--        :disabled="spinning || item.disabled"-->
        <a-button @click="handleCancel" v-if="!disClose">
          {{ isReadOnly ? "关闭" : "取消" }}
        </a-button>

        <a-button @click="handleC" v-if="CancelShou" type="primary">
          {{ elText }}
        </a-button>
        <a-button
          type="primary"
          @click="handleOk"
          :loading="loading"
          v-if="disBlock"
        >
          {{ okText }}
        </a-button>
        <!--                  <a-button-->
        <!--                    type="primary"-->
        <!--                    @click="handleOk"-->
        <!--                    :loading="loading"-->
        <!--                    v-if="disBlock"-->
        <!--                  >-->
        <!--                  </a-button>-->
        <a href="javascript:"></a>
      </template>
    </vxe-modal>
  </div>
</template>
<script>
export default {
  name: "UseModal",
  props: {
    spinning: {
      type: Boolean, //是否正在提交数据
      default: false
    },
    //确认状态
    position:{
      type:[String,Object],
      default:"center"
    },
    confirmStatus: {
      type: Boolean, //指定变量接受的类型
      default: false
    },
    statusType: {
      type: String, //指定变量接受的类型
      default: ""
    },

    modalVisible: {
      type: Boolean, //指定变量接受的类型
      default: false
    },
    ModalBtnList: {
      type: Array,
      default: () => []
    },
    modalShou: {
      type: Boolean,
      default: false
    },
    modalHeight: {
      type: String, //指定变量接受的类型
      default: "auto"
    },
    modalWidth: [String, Number],
    elText: {
      type: String,
      default: ""
    },
    elText1: {
      type: String,
      default: ""
    },
    elText2: {
      type: String,
      default: ""
    },
    disClose: {
      type: Boolean, //指定变量接受的类型
      default: false
    },
    disBlock: {
      type: Boolean, //指定变量接受的类型
      default: false
    },
    // isdisabled: {
    //   type: Boolean, //指定变量接受的类型
    //   default: false
    // },
    CancelShou: {
      type: Boolean,
      default: false
    },
    CancelShou1: {
      type: Boolean,
      default: false
    },
    isReadOnly: {
      type: Boolean, //指定变量接受的类型
      default: false
    },
    handleOkShow: {
      type: Boolean, //指定变量接受的类型
      default: true
    },
    modalTitle: {
      type: String, //指定变量接受的类型
      default: "提示"
    },
    okText: {
      type: String, //指定变量接受的类型
      default: "确定"
    },
    loading: {
      type: Boolean, //指定变量接受的类型
      default: false
    }
  },
  data() {
    return {
      className: "revert",
      Status: ""
    };
  },
  watch: {
    modalVisible(val, oldVal) {
      //普通的watch监听
      this.modalVisible = val;
      this.modalWidth = this.modalWidth;
    }
    // modalHeight(old) {
    // }
  },
  mounted() {
    console.log(this.ModalBtnList);
    // console.log(this.$slots.default[0], "----");
    // this.switCh();
  },
  methods: {
    handleZoom(type) {
      this.className = type.type === "max" ? "max" : "revert";
      this.$emit("handleZoom", this.className);
    },
    handleOk() {
      this.$emit("handleOk", this.$slots.default[0].componentInstance);
    },
    handleC() {
      this.$emit("handleC", this.$slots.default[0].componentInstance);
    },
    handleCancel() {
      this.$emit("handleCancel", false);
    },
    handleEvent(method) {
      const obj = {
        method,
        value: this.$slots.default[0].componentInstance
      };
      this.$emit("handleEvent", obj);
    }
  }
};
</script>

<style lang="less" scoped>
.revert {
  /deep/ .vxe-modal--box {
    max-height: 80% !important;
    background: #ffffff;
  }
}

.revert2 {
  /deep/ .vxe-modal--box {
    max-height: 80% !important;
    background: #1f528c;
  }
}

.max {
  /deep/ .vxe-modal--box {
    max-height: 100% !important;
  }
}

.max2 {
  /deep/ .vxe-modal--box {
    max-height: 100% !important;
    background: #1f528c;
  }
}

/deep/ .vxe-modal--content {
  overflow: hidden !important;
  overflow-y: auto !important;
}
/deep/ .vxe-modal--footer {
  .ant-btn {
    margin-right: 10px !important;
  }
}
</style>

<!--&lt;!&ndash;@Component&ndash;&gt;-->
<!--&lt;!&ndash;export default class UseModal extends Vue {&ndash;&gt;-->
<!--&lt;!&ndash;  // 模态窗口最大、最小化时改变窗口的大小&ndash;&gt;-->
<!--&lt;!&ndash;  className = "revert";&ndash;&gt;-->

<!--&lt;!&ndash;  @State Color!: string;&ndash;&gt;-->

<!--&lt;!&ndash;  // @Watch("Color")&ndash;&gt;-->
<!--&lt;!&ndash;  // ColorChange(n,o){&ndash;&gt;-->
<!--&lt;!&ndash;  //   if(n!=='#FFFFFF'){&ndash;&gt;-->
<!--&lt;!&ndash;  //     this.className='revert2'&ndash;&gt;-->
<!--&lt;!&ndash;  //   }&ndash;&gt;-->
<!--&lt;!&ndash;  //   else{&ndash;&gt;-->
<!--&lt;!&ndash;  //     this.className='revert'&ndash;&gt;-->
<!--&lt;!&ndash;  //   }&ndash;&gt;-->
<!--&lt;!&ndash;  // }&ndash;&gt;-->

<!--&lt;!&ndash;  @Prop({&ndash;&gt;-->
<!--&lt;!&ndash;    type: Object,&ndash;&gt;-->
<!--&lt;!&ndash;    default(){&ndash;&gt;-->
<!--&lt;!&ndash;      return {}&ndash;&gt;-->
<!--&lt;!&ndash;    }&ndash;&gt;-->
<!--&lt;!&ndash;  })&ndash;&gt;-->
<!--&lt;!&ndash;  readonly formVal!:any;&ndash;&gt;-->
<!--&lt;!&ndash;  form = this.formVal;&ndash;&gt;-->

<!--&lt;!&ndash;  @Prop({&ndash;&gt;-->
<!--&lt;!&ndash;    type: Boolean,&ndash;&gt;-->
<!--&lt;!&ndash;    default: false&ndash;&gt;-->
<!--&lt;!&ndash;  })&ndash;&gt;-->
<!--&lt;!&ndash;  readonly modalVisible!: boolean;&ndash;&gt;-->

<!--&lt;!&ndash;  @Prop({&ndash;&gt;-->
<!--&lt;!&ndash;    type: String,&ndash;&gt;-->
<!--&lt;!&ndash;    default: "auto"&ndash;&gt;-->
<!--&lt;!&ndash;  })&ndash;&gt;-->
<!--&lt;!&ndash;  readonly modalHeight!: string;&ndash;&gt;-->

<!--&lt;!&ndash;  @Prop({&ndash;&gt;-->
<!--&lt;!&ndash;    type: Boolean,&ndash;&gt;-->
<!--&lt;!&ndash;    default: false&ndash;&gt;-->
<!--&lt;!&ndash;  })&ndash;&gt;-->
<!--&lt;!&ndash;  readonly disClose!: boolean;&ndash;&gt;-->

<!--&lt;!&ndash;  @Prop({&ndash;&gt;-->
<!--&lt;!&ndash;    type: Boolean,&ndash;&gt;-->
<!--&lt;!&ndash;    default: true&ndash;&gt;-->
<!--&lt;!&ndash;  })&ndash;&gt;-->
<!--&lt;!&ndash;  readonly disBlock!: boolean;&ndash;&gt;-->

<!--&lt;!&ndash;  @Prop({&ndash;&gt;-->
<!--&lt;!&ndash;    type: Boolean,&ndash;&gt;-->
<!--&lt;!&ndash;    default: false&ndash;&gt;-->
<!--&lt;!&ndash;  })&ndash;&gt;-->
<!--&lt;!&ndash;  readonly isReadOnly!: boolean;&ndash;&gt;-->

<!--&lt;!&ndash;  @Prop({&ndash;&gt;-->
<!--&lt;!&ndash;    type: Boolean,&ndash;&gt;-->
<!--&lt;!&ndash;    default: true&ndash;&gt;-->
<!--&lt;!&ndash;  })&ndash;&gt;-->
<!--&lt;!&ndash;  readonly handleOkShow!: boolean;&ndash;&gt;-->

<!--&lt;!&ndash;  @Prop({&ndash;&gt;-->
<!--&lt;!&ndash;    type: String,&ndash;&gt;-->
<!--&lt;!&ndash;    default: "提示"&ndash;&gt;-->
<!--&lt;!&ndash;  })&ndash;&gt;-->
<!--&lt;!&ndash;  readonly modalTitle!: string;&ndash;&gt;-->

<!--&lt;!&ndash;  @Prop({&ndash;&gt;-->
<!--&lt;!&ndash;    type: String,&ndash;&gt;-->
<!--&lt;!&ndash;    default: "确定"&ndash;&gt;-->
<!--&lt;!&ndash;  })&ndash;&gt;-->
<!--&lt;!&ndash;  readonly okText!: string;&ndash;&gt;-->

<!--&lt;!&ndash;  @Prop({&ndash;&gt;-->
<!--&lt;!&ndash;    type: Boolean,&ndash;&gt;-->
<!--&lt;!&ndash;    default: false&ndash;&gt;-->
<!--&lt;!&ndash;  })&ndash;&gt;-->
<!--&lt;!&ndash;  readonly loading!: boolean;&ndash;&gt;-->

<!--&lt;!&ndash;  @Prop({&ndash;&gt;-->
<!--&lt;!&ndash;    type: Number,&ndash;&gt;-->
<!--&lt;!&ndash;    default: 520&ndash;&gt;-->
<!--&lt;!&ndash;  })&ndash;&gt;-->
<!--&lt;!&ndash;  readonly modalWidth!: number;&ndash;&gt;-->

<!--&lt;!&ndash;  @Emit()&ndash;&gt;-->
<!--&lt;!&ndash;  handleCancel() {&ndash;&gt;-->
<!--&lt;!&ndash;    this.handleCanceled();&ndash;&gt;-->
<!--&lt;!&ndash;    return false;&ndash;&gt;-->
<!--&lt;!&ndash;  }&ndash;&gt;-->

<!--&lt;!&ndash;  @Emit()&ndash;&gt;-->
<!--&lt;!&ndash;  handleCanceled() {&ndash;&gt;-->
<!--&lt;!&ndash;    return (this.$slots as any).default[0].componentInstance;&ndash;&gt;-->
<!--&lt;!&ndash;  }&ndash;&gt;-->

<!--&lt;!&ndash;  @Emit()&ndash;&gt;-->
<!--&lt;!&ndash;  handleOk() {&ndash;&gt;-->
<!--&lt;!&ndash;    return (this.$slots as any).default[0].componentInstance;&ndash;&gt;-->
<!--&lt;!&ndash;  }&ndash;&gt;-->

<!--&lt;!&ndash;  @Watch("formVal")&ndash;&gt;-->
<!--&lt;!&ndash;  formChange(n, o) {&ndash;&gt;-->
<!--&lt;!&ndash;    this.form = n;&ndash;&gt;-->
<!--&lt;!&ndash;    if(this.Color!=='#FFFFFF'){&ndash;&gt;-->
<!--&lt;!&ndash;      this.className='revert2'&ndash;&gt;-->
<!--&lt;!&ndash;    }&ndash;&gt;-->
<!--&lt;!&ndash;    else{&ndash;&gt;-->
<!--&lt;!&ndash;      this.className='revert'&ndash;&gt;-->
<!--&lt;!&ndash;    }&ndash;&gt;-->
<!--&lt;!&ndash;  }&ndash;&gt;-->

<!--&lt;!&ndash;  handleZoom(type) {&ndash;&gt;-->
<!--&lt;!&ndash;    if(this.Color=='#FFFFFF'){&ndash;&gt;-->
<!--&lt;!&ndash;      this.className = type.type === "max" ? "max" : "revert";&ndash;&gt;-->
<!--&lt;!&ndash;    }&ndash;&gt;-->
<!--&lt;!&ndash;    else{&ndash;&gt;-->
<!--&lt;!&ndash;      this.className = type.type === "max" ? "max2" : "revert2";&ndash;&gt;-->
<!--&lt;!&ndash;    }&ndash;&gt;-->
<!--&lt;!&ndash;  }&ndash;&gt;-->
<!--&lt;!&ndash;}&ndash;&gt;-->

<!--&lt;!&ndash;<style lang="less" scoped>&ndash;&gt;-->
<!--&lt;!&ndash;//.revert {&ndash;&gt;-->
<!--&lt;!&ndash;//  /deep/ .vxe-modal&#45;&#45;box {&ndash;&gt;-->
<!--&lt;!&ndash;//    max-height: 80% !important;&ndash;&gt;-->
<!--&lt;!&ndash;//    background:#FFFFFF;&ndash;&gt;-->
<!--&lt;!&ndash;//  }&ndash;&gt;-->
<!--&lt;!&ndash;//}&ndash;&gt;-->
<!--&lt;!&ndash;//&ndash;&gt;-->
<!--&lt;!&ndash;//.revert2 {&ndash;&gt;-->
<!--&lt;!&ndash;//  /deep/ .vxe-modal&#45;&#45;box {&ndash;&gt;-->
<!--&lt;!&ndash;//    max-height: 80% !important;&ndash;&gt;-->
<!--&lt;!&ndash;//    background:#1f528c;&ndash;&gt;-->
<!--&lt;!&ndash;//  }&ndash;&gt;-->
<!--&lt;!&ndash;//}&ndash;&gt;-->
<!--&lt;!&ndash;//&ndash;&gt;-->
<!--&lt;!&ndash;//.max {&ndash;&gt;-->
<!--&lt;!&ndash;//  /deep/ .vxe-modal&#45;&#45;box {&ndash;&gt;-->
<!--&lt;!&ndash;//    max-height: 100% !important;&ndash;&gt;-->
<!--&lt;!&ndash;//  }&ndash;&gt;-->
<!--&lt;!&ndash;//}&ndash;&gt;-->
<!--&lt;!&ndash;//&ndash;&gt;-->
<!--&lt;!&ndash;//.max2 {&ndash;&gt;-->
<!--&lt;!&ndash;//  /deep/ .vxe-modal&#45;&#45;box {&ndash;&gt;-->
<!--&lt;!&ndash;//    max-height: 100% !important;&ndash;&gt;-->
<!--&lt;!&ndash;//    background:#1f528c;&ndash;&gt;-->
<!--&lt;!&ndash;//  }&ndash;&gt;-->
<!--&lt;!&ndash;//}&ndash;&gt;-->
<!--&lt;!&ndash;//&ndash;&gt;-->
<!--&lt;!&ndash;///deep/ .vxe-modal&#45;&#45;content {&ndash;&gt;-->
<!--&lt;!&ndash;//  overflow: hidden !important;&ndash;&gt;-->
<!--&lt;!&ndash;//  overflow-y: auto !important;&ndash;&gt;-->
<!--&lt;!&ndash;//}&ndash;&gt;-->
<!--&lt;!&ndash;///deep/ .vxe-modal&#45;&#45;footer {&ndash;&gt;-->
<!--&lt;!&ndash;//  .ant-btn {&ndash;&gt;-->
<!--&lt;!&ndash;//    margin-right: 10px !important;&ndash;&gt;-->
<!--&lt;!&ndash;//  }&ndash;&gt;-->
<!--&lt;!&ndash;//}&ndash;&gt;-->
<!--&lt;!&ndash;</style>&ndash;&gt;-->



// WEBPACK FOOTER //
// src/components/UseModal.vue